import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Helmet from 'react-helmet';
import { usePage } from '@inertiajs/inertia-react';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink } from '@inertiajs/inertia-react';
import SiteLayout from '../Shared/SiteLayout';
import ProductHome from '../Shared/ProductHome';
import MapDisplay from './Components/MapDisplay';

function TOS() {
     const { app, data } = usePage().props;
     return (
          <React.Fragment>
               <Helmet>
                    <title>{app.name}</title>
               </Helmet>
               <section className="w-full bg-gray-100 pt-10 pb-10">
                    <div className="container mx-auto p-8">
                         <div className="max-w-7xl mb-10">
                              <h1 className="font-bold text-center text-4xl uppercase bg-clip-text text-emerald-800">{data.title}</h1>
                         </div>
                         {data.intro.map(({title, content}, i) => {
                              return <div key={`int${i}`} className="w-full text-justify">
                                   {(title != '') && (<h3 className="mt-4 text-md text-gray-700 font-semibold">{title}</h3>)}
                                   {(content != '') && (<p className="mt-4 text-md text-gray-600">{content}</p>)}
                              </div>
                         })}
                    </div>
               </section>

               <section className="w-full bg-white pt-10 pb-10">
                    <div className="container mx-auto md:p-8">
                         {data.data.map(({title, content}, i) => {
                              return <div key={`dat${i}`} className="w-full text-justify">
                                   {(title != '') && (<h2 className="mt-8 text-lg text-gray-700 font-semibold">{title}</h2>)}
                                   {(content != '') && (<p className="mt-1 text-md text-gray-600">{content}</p>)}
                              </div>
                         })}
                    </div>
               </section>
          </React.Fragment>
     );
}

TOS.layout = page => <SiteLayout children={page} header={'Terms of Service'} />;

export default TOS;
